/* eslint-disable import/prefer-default-export */
import React from "react";
import SectionHeader from "../../../../components/styled/Reports/SectionHeader";

export const StoriesSummary = () => (
  <SectionHeader>
    <h5>Stories completed this week (* required)</h5>
  </SectionHeader>
);
